import { clientRPC } from "@/utils/hono-client";
import { Reward } from "api/utils/reward-server-utils-v2";

export type RequestRewardReturnType = {
  success: boolean;
  rewardType: Reward | null;
  creditsAwarded: number;
};

export type GetAvailableRewardsReturnType = {
  availableRewards: Partial<Record<Reward, { credits: number }>>;
};

export const requestReward = async (
  rewardType: Reward
): Promise<RequestRewardReturnType> => {
  const response = await clientRPC.api["rewards-v2"].$post({
    json: {
      rewardType,
    },
  });

  if (!response.ok) {
    throw new Error(
      `Failed to request reward-v2 ${response.status} ${response.statusText}`
    );
  }

  const data = await response.json();

  return {
    success: data.success,
    rewardType: data.reward,
    creditsAwarded: data.creditsAwarded,
  };
};

export const getAvailableRewards =
  async (): Promise<GetAvailableRewardsReturnType> => {
    const response = await clientRPC.api["rewards-v2"].$get();

    if (!response.ok) {
      throw new Error(
        `Failed to fetch rewards-v2 ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();

    return { availableRewards: data.availableRewards };
  };
